<template>
    <div class="new-address-component">
        <div class="row">
            <div class="col-sm-12">
                <div :class="groupClassNames('company')">
                    <input readonly class="form-control" name="address[company]" v-model="value.company" placeholder="Behörde">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div :class="groupClassNames('name')">
                    <input class="form-control" name="address[name]" v-model="value.name" placeholder="Vor- und Nachname">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div :class="groupClassNames('street')">
                    <input class="form-control" name="address[street]" v-model="value.street" placeholder="Straße und Hausnummer">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8">
                <div :class="groupClassNames('city')">
                    <input class="form-control" name="address[city]" v-model="value.city" placeholder="Gemeinde">
                </div>
            </div>
            <div class="col-sm-4">
                <div :class="groupClassNames('zip')">
                    <input class="form-control" name="address[zip]" v-model="value.zip" placeholder="PLZ">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <input class="form-control" name="address[telefon]" v-model="value.telefon" placeholder="Telefon">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <input class="form-control" name="address[comment]" v-model="value.comment" placeholder="Öffnungszeiten">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  
    props: {
        countries: {
            type: [Array, Object],
            required: true
        },
        user: {
            required: true,
            default: null
        },
        value: {
            type: [Object],
            default: () => {
                return {
                    company: '',
                    name: '',
                    street: '',
                    city: '',
                    zip: '',
                    telefon: '',
                    comment: '',
                    country: '156'
                }
            }
        },
        saving: {
            type: [Boolean],
            default: false
        }
    },

    data() {
        return {
            loading: false,
            error: false,
            errorMessage: '',
        }
    },

    methods: {

        validField(name) {
            return this.value[name].length > 0;
        },

        groupClassNames(name) {
            return {
                "form-group": true,
                "has-error":  ! this.validField(name)
            }
        },

        validate() {
            return (
                this.validField('company') &&
                this.validField('name') &&
                this.validField('street') &&
                this.validField('city') &&
                this.validField('zip') &&
                this.validField('country')
            );
        },

        close() {
            this.$emit('close');
        }
    },

    created() {
        this.value.company = this.user.billing.company;
    },

    watch: {

        value: {
            deep: true,
            handler: function() {
               this.$emit('input', this.value);   
            }
        }
    }

}
</script>
